import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/core/services/auth-service.service';
import { RequestMethods } from './apiGatewayOptions.class';

export const InterceptorSkipAuthHeader = 'X-Skip-Auth';

const mfaRequest = ['RegisterWithdrawal', 'withdrawal-accounts'];
export const ExcludeAuthHeader = new HttpHeaders().set(
  InterceptorSkipAuthHeader,
  '',
);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.headers.has(InterceptorSkipAuthHeader)) {
      const headers = request.headers.delete(InterceptorSkipAuthHeader);
      return next.handle(request.clone({ headers }));
    }

    let updatedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.authorizationSession}`,
      },
    });

    if (
      mfaRequest.some((value) => request.url.includes(value)) &&
      request.method === RequestMethods.Post &&
      request.body &&
      request.body.code
    ) {
      updatedRequest = updatedRequest.clone({
        setHeaders: {
          'X-MFA-CODE': request.body.code,
        },
      });
    }

    return next.handle(updatedRequest);
  }
}
